import { formatInTimeZone } from "date-fns-tz";
export const supportedLanguages = [
  {
    name: "English",
    shortCode: "en",
    emoji: "🇺🇸",
  },
  {
    name: "Serbian",
    shortCode: "sr",
    emoji: "🇷🇸",
  },
  {
    name: "Hungarian",
    shortCode: "hu",
    emoji: "🇭🇺",
  },
];

export const supportedLanguageShortCodes = supportedLanguages.map(
  (item) => item.shortCode
);

export const getSupportedLanguage = (shortCode) => {
  const matches = supportedLanguages.filter(
    (lang) => lang.shortCode === shortCode
  );
  if (matches.length > 0) {
    return matches[0];
  } else {
    return supportedLanguages[0];
  }
};

export const formatDate = (dateString) => {
  if (dateString) {
    const date = new Date(dateString);
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const formattedDate = formatInTimeZone(
      date,
      timeZone, // i want this format Mon 12, 2021 12:00:00
      "EEE dd MMM yyyy || HH:mm:ss"
    );
    return formattedDate;
  }
};
